var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 479;
var h = 479;
var nm = "basket Swing  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Basket",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    235.521,
                    -90.725,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    499.521,
                    175.275,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                127.026
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                -127.026
                            ],
                            [
                                127.026,
                                0
                            ]
                        ],
                        v: [
                            [
                                732.5,
                                500.5
                            ],
                            [
                                502.5,
                                730.5
                            ],
                            [
                                272.5,
                                500.5
                            ],
                            [
                                502.5,
                                270.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -8.441,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -8.441
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        8.441,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        8.441
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        8.441,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        8.441
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -8.441,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -8.441
                                    ]
                                ],
                                v: [
                                    [
                                        -86.918,
                                        -86.084
                                    ],
                                    [
                                        88.142,
                                        -86.084
                                    ],
                                    [
                                        103.426,
                                        -70.801
                                    ],
                                    [
                                        103.426,
                                        -62.444
                                    ],
                                    [
                                        88.142,
                                        -47.16
                                    ],
                                    [
                                        -86.918,
                                        -47.16
                                    ],
                                    [
                                        -102.201,
                                        -62.444
                                    ],
                                    [
                                        -102.201,
                                        -70.801
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 5",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 1,
                        ty: "sh",
                        ix: 2,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -13.864,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -3.554,
                                        -13.401
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        13.864,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        3.554,
                                        -13.401
                                    ]
                                ],
                                v: [
                                    [
                                        -25.253,
                                        -160.28
                                    ],
                                    [
                                        25.519,
                                        -160.28
                                    ],
                                    [
                                        55.065,
                                        -137.548
                                    ],
                                    [
                                        68.598,
                                        -86.513
                                    ],
                                    [
                                        68.598,
                                        -86.513
                                    ],
                                    [
                                        -68.333,
                                        -86.513
                                    ],
                                    [
                                        -54.799,
                                        -137.548
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 6",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 2,
                        ty: "sh",
                        ix: 3,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        34.388,
                                        -2.577
                                    ],
                                    [
                                        34.388,
                                        12.777
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 2",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 3,
                        ty: "sh",
                        ix: 4,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        -15.945
                                    ],
                                    [
                                        0,
                                        12.777
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 3",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 4,
                        ty: "sh",
                        ix: 5,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -34.388,
                                        -2.577
                                    ],
                                    [
                                        -34.388,
                                        12.777
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 4",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ind: 5,
                        ty: "sh",
                        ix: 6,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        7.082,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1.634,
                                        6.891
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -1.634,
                                        6.891
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -7.082,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -88.562,
                                        -45.192
                                    ],
                                    [
                                        88.562,
                                        -45.192
                                    ],
                                    [
                                        69.917,
                                        33.434
                                    ],
                                    [
                                        55.046,
                                        45.192
                                    ],
                                    [
                                        -55.046,
                                        45.192
                                    ],
                                    [
                                        -69.917,
                                        33.434
                                    ],
                                    [
                                        -88.562,
                                        -45.192
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.525490224361,
                                0.450980395079,
                                0.705882370472,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                499.521,
                                198.767
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                -358.508
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6,
                            x: "var $bm_rt;\nvar veloc, amplitude, decay;\nveloc = 7;\namplitude = 70;\ndecay = 1.4;\n$bm_rt = $bm_div($bm_mul(amplitude, Math.sin($bm_mul(veloc, time))), Math.exp($bm_mul(decay, time)));"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 4",
                np: 7,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 7.00000028511585,
        op: 907.000036942867,
        st: 54.0000021994651,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Bgrnd",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    236,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        -127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        127.026,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.972549021244,
                                0.949019610882,
                                0.972549021244,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var BasketSwing = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, BasketSwing as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=BasketSwing.json.es.js.map
